import { createSelector } from "@reduxjs/toolkit";
import { getProductPickerProducts } from "@src/store/slices/productPicker";
import { getProductPickerSelectedProductMap } from "@src/store/slices/productPicker/selectors/getProductPickerSelectedProductMap";

export const getProductPickerSelectionType = createSelector(
  getProductPickerProducts,
  getProductPickerSelectedProductMap,
  (products, selectedProductsMap) => {
    let selectedCount = 0;
    for (const product of products) {
      if (selectedProductsMap[product.id] !== undefined) {
        selectedCount++;
      }
    }
    if (selectedCount === 0) {
      return "none";
    } else if (selectedCount < products.length) {
      return "partial";
    } else {
      return "all";
    }
  }
);
